import React from 'react'
import { type ClickNavigationSection } from '../../../components/NavigationWithSideBar/ClickNavigation'
import { type IntegrationServiceId, isFpCodeSelectionEnabledForService } from '../../../common/integrations'
import { useAppSelector } from '../../../store/hooks'
import { selectCreateNewCRMContact } from '../../../store/meetingSummary/contactUpdate'
import { ClicFpCodeUpdateSections } from './ClicFpCodeUpdateSections'

const NO_EXTRA_SECTIONS: ClickNavigationSection[] = []

interface ServiceSpecificContactUpdateSectionsProps {
  serviceId: IntegrationServiceId
  children: (extraSections: ClickNavigationSection[]) => React.ReactNode
}

export const ServiceSpecificContactUpdateSections: React.FC<ServiceSpecificContactUpdateSectionsProps> = ({ serviceId, children }) => {
  const createNewCRMContact = useAppSelector(selectCreateNewCRMContact)

  if (isFpCodeSelectionEnabledForService(serviceId) && !createNewCRMContact) {
    return <ClicFpCodeUpdateSections>{children}</ClicFpCodeUpdateSections>
  }

  return <>{children(NO_EXTRA_SECTIONS)}</>
}
